import { Button } from "@/components/ui/button";

interface CollapseToggleProps {
  allCollapsed: boolean;
  onToggle: () => void;
}

export function CollapseToggle({ allCollapsed, onToggle }: CollapseToggleProps) {
  return (
    <Button
      variant="link"
      size="sm"
      className="cursor-pointer h-8 text-xs gap-1.5"
      onClick={onToggle}
    >
      <svg
        className={`transition-transform ${allCollapsed ? "" : "rotate-90"}`}
        width="12" height="12" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
      {allCollapsed ? "Expand All" : "Collapse All"}
    </Button>
  );
}
